import { useAtom, useSetAtom } from 'jotai';
import { loadable } from 'jotai/utils';
import { useEffect } from 'react';
import { entityCountsCacheAtom } from '~/atoms/gridData';
import { productInstancesDataAtom } from '~/atoms/productMatrix';
export const productInstancesLoadingAtom = loadable(productInstancesDataAtom);
/**
 * Hook for syncing product instance count to entityCounts.
 * Used by ProductMatrixPage and FilterBarWrapper to keep product count in sync.
 */
export function useSyncProductInstanceCount() {
    const [productInstancesLoading] = useAtom(productInstancesLoadingAtom);
    const setEntityCounts = useSetAtom(entityCountsCacheAtom);
    useEffect(() => {
        if (productInstancesLoading.state === 'hasData') {
            const data = productInstancesLoading.data;
            const count = data.length;
            setEntityCounts((prev) => ({ ...prev, product: count }));
        }
    }, [
        productInstancesLoading.state,
        productInstancesLoading.state === 'hasData'
            ? productInstancesLoading.data
            : null,
        setEntityCounts
    ]);
}
